import { useDispatch } from 'react-redux';
import React, {useState } from 'react';
import { RxCross2 } from 'react-icons/rx';

import { CustomLoader } from '../../../services/Reducer';
import apiClient from '../../../api/apiClient';
import authServices from '../../../services/AuthServices';



const Add_table = ({ show, toggle, refreshData, AddcurrentPage  }) => {
  const [formData, setFormData] = useState({
    commodity: '',

  });
  const [errors, setErrors] = useState({}); // Error state
  const dispatch = useDispatch();

  const loader = (display) => {
    dispatch(CustomLoader(display));
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });

    // Clear the error for the field being edited
    setErrors({ ...errors, [name]: '' });
  };

  const validateForm = () => {
    let formErrors = {};

    if (formData.commodity === '') {
      formErrors.commodity = 'commodity cannot be empty';
    }

    setErrors(formErrors);
    return Object.keys(formErrors).length === 0; // No errors
  };

  const token = authServices.getToken();
  const handleSubmit = async (e) => {
    // e.preventDefault();
    if (!validateForm()) {
      return; // Stop submission if there are validation errors
    }

    loader('enable');

    try {
      
      const response = await apiClient.post('/api/admin/commodity/add', formData, {
      
              headers: {
                'access_token': token,
              },
      
            });      
      if (response.data.Status === "SUCCESS") {
      setFormData({
        commodity: '',

      });
    }
    else{
      console.log(response.data.message)
    }
    }
    catch (error) {
      console.error('catch Error :- ', error.response ? error.response.data.message : error);
    }
    finally {
      refreshData(AddcurrentPage);
      loader('disable');
      toggle(); // Close the modal after submission
      // window.location.reload();
    }
  };
  return (
    <>
      {show && (
        <>
          <div className="modal fade show d-block" id="exampleModalScrollable" tabIndex={-1} role="dialog" aria-labelledby="exampleModalScrollableTitle" aria-hidden="true">
            <div className="modal-dialog modal-dialog-scrollable">
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title" id="exampleModalScrollableTitle">Add commodity</h5>
                  <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" onClick={toggle} >< RxCross2 /></button>
                </div>
                <div className="modal-body-custom">
                  <form >
                  
                    <div className="spacing" style={{marginTop:'-1vw'}}>
                      <label htmlFor="commodity" className="label-custom">Commodity</label>
                      <input
                        type="text"
                        className={`input-custom ${errors.commodity ? 'input-error' : ''}`}
                        id="commodity"
                        name="commodity"
                        value={formData.commodity}
                        onChange={handleChange}
                      />
                    </div>
                    
                  </form>
                </div>

                <div className="modal-footer">

                    <button type="button" style={{ backgroundColor: '#F0F0F0', color: '#000', fontWeight: '500', border: "1px solid #d7dde2" }} className="btn " data-bs-dismiss="modal" onClick={toggle}>
                    Close
                  </button>
                  <button type="button" style={{ color: 'white', fontWeight: '500' }} className="btn btn-primary" onClick={handleSubmit}>
                    Submit
                  </button>
                </div>
              </div>
              {/* /.modal-content */}
            </div>
            {/* /.modal-dialog */}
          </div>
          {/* /.modal */}
        </>
      )}
    </>
  );
};

export default Add_table;
